/**
 * DraftWatermark — overlays "DRAFT · NOT FOR PUBLICATION" diagonally
 * across a rendered preview. Removed once the post is approved.
 *
 * Usage:
 *   <div className="relative">
 *     <img src={render.url} alt={altText} />
 *     <DraftWatermark show={!post.approved} />
 *   </div>
 */
export default function DraftWatermark({ show = true, label = "DRAFT · NOT FOR PUBLICATION" }) {
  if (!show) return null;
  return (
    <div
      data-testid="draft-watermark"
      className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden select-none"
      aria-hidden="true"
    >
      <div
        className="text-rose-600/40 font-black tracking-widest whitespace-nowrap"
        style={{
          transform: "rotate(-18deg)",
          fontSize: "clamp(14px, 4.5vw, 42px)",
          textShadow:
            "0 2px 4px rgba(255,255,255,0.6), 0 -2px 4px rgba(255,255,255,0.6)",
        }}
      >
        {label} · {label} · {label}
      </div>
      {/* Repeating stripe underlay so the watermark reads on any image. */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "repeating-linear-gradient(-18deg, rgba(190,18,60,0.25) 0 2px, transparent 2px 48px)",
        }}
      />
    </div>
  );
}
